import { useTranslation } from 'react-i18next'

const AVATARS = ['🦊', '🐸', '🤖', '👻', '🦄', '🐙', '🦖', '🐝', '🦉', '🐋', '🦝', '🐲', '🦋', '🐌', '🦜', '🦡']
const AVATAR_COLORS = ['#ff7a59', '#72df78', '#6bd4ff', '#c9a5ff', '#ff79ba', '#9b8cff', '#83d86b', '#ffd454', '#e99d52', '#60c7cc', '#b9a78c', '#dc5964', '#84b9e8', '#c0d36f', '#e875af', '#a9a1d8']

export function MiniBrand({ onClick }) {
  const { t } = useTranslation('glitch')
  return (
    <button className="mini-brand mini-brand--button" type="button" onClick={onClick} aria-label={t('brand.aria')}>
      <span>2</span><i>+</i><span>1</span>
    </button>
  )
}

export function LogoMark() {
  const { t } = useTranslation('glitch')
  return (
    <div className="brand" aria-label={t('brand.aria')}>
      <div className="brand__line brand__line--top">
        <span className="brand__two">{t('brand.two')}</span>
        <span className="brand__truths">{t('brand.truths')}</span>
      </div>
      <span className="brand__one">{t('brand.one')}</span>
      <span className="brand__glitch" data-text={t('brand.glitch')}>{t('brand.glitch')}</span>
      <span className="brand__bolt" aria-hidden="true">↯</span>
    </div>
  )
}

export function Avatar({ player, size = 'medium' }) {
  return (
    <span
      className={`avatar avatar--${size}`}
      style={{ '--avatar-color': AVATAR_COLORS[player?.avatarIndex ?? 0] }}
      aria-hidden="true"
    >
      {AVATARS[player?.avatarIndex ?? 0]}
    </span>
  )
}

export function LoadingCard({ message }) {
  const { t } = useTranslation('common')
  return (
    <main className="connection-screen">
      <div className="connection-card">
        <div className="glitch-loader"><span /><span /><span /></div>
        <p>{message ?? t('loading.connecting')}</p>
      </div>
    </main>
  )
}

export function ErrorCard({ title, message, onBack }) {
  const { t } = useTranslation(['common', 'glitch'])
  return (
    <main className="connection-screen">
      <section className="connection-card connection-card--error">
        <span className="error-face">×﹏×</span>
        <h1>{title ?? t('host.busted', { ns: 'glitch' })}</h1>
        <p>{message}</p>
        <button className="button button--primary" type="button" onClick={onBack}>{t('nav.back', { ns: 'common' })}</button>
      </section>
    </main>
  )
}

export function InlineError({ message }) {
  if (!message) return null
  return <p className="inline-error" role="alert"><span>!</span>{message}</p>
}

export function ConnectionPill({ connected }) {
  const { t } = useTranslation('common')
  return <span className={`connection-pill ${connected ? '' : 'connection-pill--offline'}`}><i />{connected ? t('status.live') : t('status.reconnecting')}</span>
}

export function ScoreList({ players, highlightId }) {
  const ordered = [...players].sort((a, b) => b.score - a.score || a.name.localeCompare(b.name))
  return (
    <ol className="score-list">
      {ordered.map((player, index) => (
        <li key={player.id} className={player.id === highlightId ? 'score-list__highlight' : ''}>
          <b>{index + 1}</b><Avatar player={player} size="tiny" /><span>{player.name}</span><strong>{player.score.toLocaleString()}</strong>
        </li>
      ))}
    </ol>
  )
}

export function PhaseBadge({ round }) {
  const { t } = useTranslation('common')
  if (!round) return null
  return <span className="phase-badge">{t('game.round', { current: round.number, total: round.total })}</span>
}
